import React from "react"

export default function ChevronIcon(props) {
  return (
    <svg width={15} height={8} viewBox="0 0 15 8" {...props}>
      <path d="M.5.5l6.952 7L14.5.5" stroke="#979797" strokeWidth="2" fill="none" fillRule="evenodd" />
    </svg>
  )
}
